import React from 'react';

import { isEmptyString } from 'Shared/helpers';
import { useToggle } from 'Shared/utils/hooks';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  text: string;
  fullText?: boolean;
  className?: string;
};

export default function Transcription({ text, fullText = false, className }: Props) {
  const { tr } = useTranslation();
  const [transcriptionExpanded, toggleTranscriptionExpanded] = useToggle(false);

  if (isEmptyString(text)) {
    return (
      <p className={`small text-muted ${className}`}>{tr('perform.video_player.transcription.no_transcription')}</p>
    );
  }
  if (!text) {
    return <p className={`small text-muted ${className}`}>{tr('perform.video_player.transcription.transcribing')}</p>;
  }
  if (text.length <= 120 || fullText) {
    return (
      <p className={`small text-muted ${className}`}>
        {tr('perform.video_player.transcription.transcription_with_text', text)}
      </p>
    );
  }

  return (
    <p className={`small text-muted ${className}`}>
      {tr(
        'perform.video_player.transcription.transcription_with_text',
        transcriptionExpanded ? text : `${text.substring(0, 120)}...`
      )}{' '}
      <button
        type="button"
        className="d-inline btn btn-link p-0"
        onClick={toggleTranscriptionExpanded}
        style={{ fontSize: '100%', verticalAlign: 'top', borderTop: 'none' }}
      >
        {transcriptionExpanded
          ? tr('perform.video_player.transcription.read_less')
          : tr('perform.video_player.transcription.read_more')}
      </button>
    </p>
  );
}
